import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';
import { WIDGET_SETTINGS_UPDATE } from './widgetSettingsActions';

const initialState = { currencyId: '840', currencyCode: 'USD' };

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case WIDGET_SETTINGS_UPDATE:
            return {
                ...state,
                currencyId: action.payload.currencyId,
                currencyCode: action.payload.currencyCode
            };
        default:
            return state;
    }
}

export const getWidgetSettingsEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'widgetSettings')
);
